export default {
  "Language-es": "Español",
  Login: "Acceso",
};
